<div class="col-12" *ngIf="report">
  <iframe
    style="border: 0"
    title="Report"
    width="100%"
    height="900"
    [src]="report | safeUrl"
    allowfullscreen="false"
  >
  </iframe>
</div>
